export default __webpack_public_path__ + "static/media/pg-1.e6ab4f41.jpg";